export enum HeaderType {
    category = '0',
    section = '1',
}

export enum SectionSubType {
    normal,
    pinned,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/eventGrid/enums.ts